export type Links = {
  lang: string;
  href?: string;
};

export enum ORDER {
  First = 2,
  Last = 1,
  None = 0,
  Skipped = 3,
}

type LanguageDetails = {
  langCode: string;
  order: ORDER;
};

export type Language = {
  [key: string]: LanguageDetails;
};

export type HrefLangsTagsProps = {
  hrefLangs: Links[];
  path: string;
};

export type SeoProps = {
  canonicalPath?: string;
  children?: React.ReactNode;
};
